<template>
  <div class="wrapper" :style="boxSize" style="overflow-y:auto" ref="scroller">
    <div v-if="historyLoading" @click="$emit('loadHistory')">{{historyConfig.tip}}</div>
    <div class="scroller">
      <div class="web__main" ref="main">
        <div
          class="web__main-item"
          v-for="(item,index) in list"
          :key="index"
          :class="{'web__main-item--mine':item.mine}"
          >
          <div class="web__main-user">
            <img :src="getUserInfoImg(item)" @click="bindClick('img',item)"/>
            <cite @click="bindClick('nickname',item)" :class="{'web__main-item--mine--child':item.ask&&item.mine,'web__main-item--child':item.ask&&!item.mine}">
              {{item.name}}
              <i>{{item.date}}</i>
            </cite>
          </div>
          <div class="web__main-text">
            <div class="web__main-arrow"></div>
            <div v-if="item.item" v-for="(t,index) in item.item" :key="index">
              <itemTalk v-if="t" :text="t"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="downBtn" v-if="!isBottom" @click="scrollBottom" alt="直达底部">
      <span v-if="unread">{{unread}}</span>
    </div>
  </div>
</template>

<script>
  //非聊天窗体，取消所有的定时器，不需要刷新
  import Scroll from "../../../util/scroll";
  import itemTalk from "./itemTalk";
  import user from '../../../assets/image/user.png'
  import AIDefault from '../../../assets/image/AIDefault.png'

  export default {
    name: "chatList",
    components:{itemTalk},
    filters:{
      setWidth(value) {
        let width = value
        if (`${value}`.match(/^\d+$/)) {
          width = value + 'px'
        }
        return width
      }
    },
    props:{
      pageConfig:{
        type:Object,
        default:()=>({
          width:'100vw'
        })
      },
      list: {
        type:Array,
        default:()=>({})
      },
      config:{
        type:Object,
        default:()=>({
          width: '6200px',
          height:'500px'
        })
      }
    },
    data(){
      return {
        load:false,
        scroll:null,
        scrollTimer:null,
        beforeTitle:'',
        titleTimer:'',
        loadHistory:false,
        historyLoading:false
      }
    },
    watch:{
      load(newval) {
        if (newval) {
          /*setTimeout(()=>{
            this.scroll && this.scroll.refresh()
            this.load = false
          },1000)*/
          this.scroll && this.scroll.refresh()
          this.load = false
        }
      },
      list(newval) {
        if (newval) {
          this.$nextTick(()=>{
            /*setTimeout(()=>{
              let reset = false
              if (this.historyLoading) {
                reset = true
                this.closeTopTip()
                this.$nextTick(()=>{
                  this.scroll.toBeforePosition()
                })
              }
              this.load = true
              this.childnodeLoad()
              if (reset) {this.scroll.resetTop()}
              if (this.scrollType === 'scroll') {
                this.scrollBottom()
              }
            },300)*/
            let reset = false
            if (this.historyLoading) {
              reset = true
              this.closeTopTip()
              this.$nextTick(()=>{
                this.scroll.toBeforePosition()
              })
            }
            this.load = true
            this.childnodeLoad()
            if (reset) {this.scroll.resetTop()}
            if (this.scrollType === 'scroll') {
              this.scrollBottom()
            }
          })
        }
      },
      'config.scrollToButton'(newval) {
        if (newval) {
          this.scrollBottom()
        }
      },
      unread(newval) {
        if (newval) {
          this.beforeTitle && this.resetTitle(this.beforeTitle);
          this.saveTitle();
          this.changeTitle();
          this.showBrowser();
        } else {
          this.resetTitle(this.beforeTitle)
        }
      }
    },
    computed:{
      boxSize() {
        let {height='500px',width='600px'} = this.config || {}
        if (`${height}`.match(/\d$/)) {
          height += 'px'
        }
        if (`${width}`.match(/\d$/)) {
          width += 'px'
        }
        const style = {height, width}
        return style
      },
      historyConfig() {
        const {historyConfig:{tip='',activate=false}={}} = this.config
        return {tip,activate}
      },
      isBottom() {
        return this.scroll && this.scroll.isBottom
      },
      scrollType() {
        const {scrollType:type='noroll'} = this.config
        return type
      },
      unread() {
        const {unread=0} = this.scroll || {}
        return unread
      }
    },
    methods:{
      scrollBottom() {
        if (this.scroll) {
          this.scroll.refresh()
          /*setTimeout(()=>{
            this.scroll.scrollTo(0,this.scroll.maxScrollY,200)
          },800)*/
          this.scroll.scrollTo(0,this.scroll.maxScrollY,200)
        }
      },
      bindClick(type, data) {
        this.$emit('click',{type,data})
      },
      getUserInfoImg(item) {
        if (item.img) {
          return item.img;
        } else {
          if (item.mine) {
            return AIDefault;
          } else {
            return user;
          }
        }
      },
      createScroll() {
        const that = this
        const dom = this.$refs.scroller
        this.scroll = new Scroll(dom,{
          click:true,
          scrollbars:false,
          mouseWheel:true,
          preventDefault:false,
          interactiveScrollbars:true,
          hijackInternalLinks:true,
        })
        dom.addEventListener(('ontouchstart' in window) ? 'touchstart':'mousedown', function (e) {
          e.stopPropagation()
          var target = e.target
          if (target.tagName === 'SPAN') {
            var clipBoardContent = target.innerText
            if (!clipBoardContent) return
            const input = document.createElement('input')
            document.body.appendChild(input)
            input.setAttribute('value',clipBoardContent)
            input.select()
            if (document.execCommand('copy')) {
              document.execCommand('copy')
              that.$Message.info('复制成功！')
            }
            document.body.removeChild(input)
          }
        })
        this.scroll.on('scrollEnd',function () {
          that.scrollTop()
          if (that.historyLoading) return
          that.scroll.savePosition()
          that.scroll.read()
        })
      },
      scrollTop() {
        const {isTop} = this.scroll
        if (isTop) {
          if (this.loadHistory) {
            this.historyLoading = true;
          } else {
            this.loadHistory = true
          }
          return
        }
        this.closeTopTip()
      },
      closeTopTip() {
        this.loadHistory = false
        this.historyLoading = false
      },
      childnodeLoad() {
        if (this.scrollType === 'scroll') return
        const parent = this.$refs.main
        if (!parent) return;
        const childs = parent.children
        if (Array.isArray(childs)) {
          childs.forEach(i=>{
            const top = i.offsetTop
            this.scroll.setPosition(top,i)
          });
        }

      },
      scrollRefresh() {
        /*setTimeout(()=>{
          this.scroll && this.scroll.refresh()
          this.scrollRefresh()
        },1000)*/
        this.scroll && this.scroll.refresh()
        return
      },
      saveTitle() {
        const {title} = document
        this.beforeTitle = title
      },
      resetTitle(title) {
        document.title = title
        //clearTimeout(this.titleTimer)
      },
      changeTitle() {
        const that = this
        let flage = 0
        change()

        function change() {
          let title = '[未读]'
          if (flage) {
            title = '['+that.unread + '条]'
          }
          flage = !flage
          /*that.titleTimer = setTimeout(()=>{
            that.resetTitle(title + that.beforeTitle)
            change()
          },1000)*/
        }
      },
      showBrowser() {
        if (window.Notification && Notification.permission !== 'denied') {
          const { unread } = this
          Notification.requestPermission(function (status) {
            if (status === 'granted') {
             new Notification('新消息',{
               body :`您总共有${unread}条消息未读`
             })
            }
          });
        }
      }
    },
    mounted() {
      this.createScroll()
      this.scrollRefresh()
    }
  }
</script>

<style scoped>
.wrapper::-webkit-scrollbar-thumb {
    background-color: #21698a;
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 3px;
  }
  .wrapper::-webkit-scrollbar {
    width: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/aiManager/chat/chatList.vue